<script setup lang="ts">
import { InputPrimary } from '@shared/ui/input'
import { FormRow } from '@shared/ui/form-row'

import { useTutorApplicationStore } from '../../model/store'
import { useNationality } from '../../model/additional-questions/nationality.hooks'

defineOptions({
  name: 'InputNationality',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  setNationality,
} = useNationality()

</script>

<template>
  <FormRow
    label="Nationality"
    required
  >
    <InputPrimary
      id="parent-nationality"
      name="parent_nationality"
      type="text"
      placeholder="Nationality"
      :required="true"
      :value="tutorApplicationStore.form.nationality"
      :mode="mode"
      error-message="Please enter your nationality"
      @input="setNationality"
    />
  </FormRow>
</template>
